import { capitalize } from "lodash";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from "reactstrap";

export const UserDetailsModal = (props: any) => {
  const { isOpen, toggle, data } = props;

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>
        <h5 className="modal-title">User Details</h5>
      </ModalHeader>
      <ModalBody>
        <>
          <div className="mb-4">
            <div className="table-responsive">
              <Table className="table-borderless mb-0">
                <tbody>
                  <tr>
                    <th scope="row" style={{ width: "200px" }}>
                      ID :
                    </th>
                    <td>#{data?.id}</td>
                  </tr>
                  <tr>
                    <th scope="row">Name:</th>
                    <td>{data?.name}</td>
                  </tr>
                  <tr>
                    <th scope="row">Contact:</th>
                    <td>{data?.phone}</td>
                  </tr>
                  <tr>
                    <th scope="row">Email:</th>
                    <td>{data?.email}</td>
                  </tr>
                  <tr>
                    <th scope="row">Role:</th>
                    <td>{capitalize(data?.role?.name)}</td>
                  </tr>
                  <tr>
                    <th scope="row">Address:</th>
                    <td>{data?.address}</td>
                  </tr>
                  <tr>
                    <th scope="row">Status :</th>
                    <td>
                      {capitalize(data?.is_active ? "Active" : "In Active")}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>
        </>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};
